export default "__VITE_PUBLIC_ASSET__2a389b87__"